// Stundenhöhe des Kalender-Grids: füllt ~(100vh − 160px) mit 12 sichtbaren
// Stunden. Exakt die Formel, die vorher einmalig beim Modul-Load in
// hour-grid.tsx ausgewertet wurde — jetzt pur + reaktiv aufrufbar
// (resize/orientationchange), damit Rotation am Phone nicht bis zum Reload
// mit der falschen Skala rendert.

export const HOUR_HEIGHT_MIN = 28
export const HOUR_HEIGHT_MAX = 56

export function computeHourHeight(viewportHeight: number): number {
  return Math.max(
    HOUR_HEIGHT_MIN,
    Math.min(HOUR_HEIGHT_MAX, Math.floor((viewportHeight - 160) / 12)),
  )
}
